import { render, staticRenderFns } from "./comRecommendedProducts.vue?vue&type=template&id=5df2f551&scoped=true"
import script from "./comRecommendedProducts.vue?vue&type=script&lang=js"
export * from "./comRecommendedProducts.vue?vue&type=script&lang=js"
import style0 from "./comRecommendedProducts.vue?vue&type=style&index=0&id=5df2f551&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df2f551",
  null
  
)

export default component.exports